import { render, staticRenderFns } from "./AgencyAgents.vue?vue&type=template&id=fb37ff66&scoped=true&"
import script from "./AgencyAgents.vue?vue&type=script&lang=js&"
export * from "./AgencyAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb37ff66",
  null
  
)

component.options.__file = "AgencyAgents.vue"
export default component.exports